import { useSelector } from "react-redux";
import { RootState } from "../store";
import { useGetWorksByUserQuery } from "../store/services/workService";
import { UserWorksParams } from "../store/types/work.types";

/**
 * Fetches works for the currently selected user in Redux.
 * Wraps useGetWorksByUserQuery och plockar userId från user-slicen.
 */
export function useActiveUserWorks(params?: UserWorksParams) {
  const selectedUserId = useSelector(
    (state: RootState) => state.user.selectedUserId
  );
  return useGetWorksByUserQuery({
    userId: selectedUserId ?? undefined,
    ...params,
  });
}
